<template>
    <div id="contenedor-main-listado-infraestructura">
        <template
            v-if="!$vuetify.breakpoint.mobile">
            <desktop
              :listadoInfraestructura="listadoInfraestructura"
              >
            </desktop>
        </template>
        <template
            v-else>
            <!-- <mobile
              :listadoInfraestructura="listadoInfraestructura"
              >
            </mobile> -->
            <desktop
              :listadoInfraestructura="listadoInfraestructura"
              >
            </desktop>
        </template>
    </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'MainListadoInfraestructuras',
  props: {
    listadoInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss">

</style>
